
class EnvHelper {
    public static isDevelopmentQa = () => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'PERSON';
        } else if (ENV_NAME === 'qa') {
            return 'PERSON QA';
        } else if (ENV_NAME === 'dev') {
            return 'PERSON DEV';
        } else {
            return 'PERSON ENV NOT FOUND';
        }
    };
}

export default EnvHelper;